<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">申购管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>五折申购抽奖记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input placeholder="请输入用户ID" v-model="forms.userId"></el-input>
        <el-input
          placeholder="请输入项目ID"
          v-model="forms.purchaseId"
          clearable
        ></el-input>
        <el-input placeholder="请输入签号" v-model="forms.ballotNum"></el-input>
        <el-select
          v-model="forms.gitStatus"
          placeholder="请选择抽奖状态"
          @change="searchBallot"
        >
          <el-option
            v-for="item in gitStatuss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="forms.payStatus"
          placeholder="请选择支付状态"
          v-if="forms.gitStatus == 2"
        >
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in payStatuss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="forms.returnStatus"
          placeholder="请选择解冻状态"
          v-if="forms.gitStatus == 2"
        >
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in returnStatuss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="forms.sendStatus"
          placeholder="请选择发币状态"
          v-if="forms.gitStatus == 2"
        >
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in sendStatuss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="searchBallot">查询</el-button>
        <set-gitnum @refresh="getList" v-if="forms.gitStatus == 1"></set-gitnum>
        <el-button type="success" @click="sendOne" v-if="forms.gitStatus > 1"
          >发放单笔中奖奖励</el-button
        >
        <el-button type="success" @click="sendMore" v-if="forms.gitStatus > 1"
          >发放多笔中奖奖励</el-button
        >
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import setGitnum from './components/setGitNum';

export default {
  name: 'discountRecords',
  data() {
    return {
      forms: {
        userId: '',
        purchaseId: '',
        ballotNum: '',
        gitStatus: '0',
        payStatus: '',
        returnStatus: '',
        sendStatus: ''
      },
      gitStatuss: [
        { value: '0', label: '未抽奖' },
        { value: '1', label: '抽奖中' },
        { value: '2', label: '抽奖成功' },
        { value: '3', label: '抽奖失败' }
      ],
      payStatuss: [
        { value: '1', label: '支付成功' },
        { value: '2', label: '支付失败' },
        { value: '3', label: '支付超时' }
      ],
      returnStatuss: [
        { value: '1', label: '解冻成功' },
        { value: '2', label: '解冻失败' },
        { value: '3', label: '解冻超时' }
      ],
      sendStatuss: [
        { value: '1', label: '发币成功' },
        { value: '2', label: '发币失败' },
        { value: '3', label: '发币超时' }
      ]
    };
  },
  components: {
    List,
    setGitnum
  },
  computed: {},
  methods: {
    ...mapActions('discountrecord', [
      'getaward',
      'confirmOne',
      'confirconfirmMoremGitNum'
    ]),
    searchBallot() {
      this.getaward(this.forms);
    },
    getList(data = {}) {
      this.getaward({
        ...this.forms,
        ...this.pagination,
        ...data
      });
    },
    sendOne() {
      this.confirmOne({ purchaseId: this.forms.purchaseId }).then(() => {
        this.$message({
          message: '发放成功！',
          type: 'success'
        });
        this.$emit('refresh', {
          page: 1
        });
      });
    },
    sendMore() {
      this.confirconfirmMoremGitNum({ purchaseId: this.forms.purchaseId }).then(
        () => {
          this.$message({
            message: '发放成功！',
            type: 'success'
          });
          this.$emit('refresh', {
            page: 1
          });
        }
      );
    }
  },
  mounted() {
    if (this.$route.params.purchaseId) {
      this.forms.purchaseId = this.$route.params.purchaseId;
      this.getaward(this.forms);
    }
  }
};
</script>
